import { style } from '@vanilla-extract/css'

const card = style({
  width: '100%',
  backgroundColor: '#FFFFFF',
  borderRadius: '16px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  boxShadow: '0px 8px 16px 0px #C5C5C50D'
})

const heading = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
})

const dates = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '19px',
  fontWeight: '700',
  lineHeight: '1.5',
})

const note = style({
  color: '#828282',
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const warn = style([
  note,
  {
    color: '#ED0006',
  },
])

const noteIcon = style({
  width: '16px',
  height: '21px',
})

const delayList = style({
  paddingLeft: '16px',
  listStyleType: 'disc',
});

const dateOption = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
});

const fastestOption = style({
  fontSize: '12px',
  fontWeight: '700',
  lineHeight: '1.5',
});

export const styles = {
  card,
  heading,
  dates,
  note,
  warn,
  noteIcon,
  delayList,
  dateOption,
  fastestOption,
}
